// Generated by ReScript, PLEASE EDIT WITH CARE


let serviceWorkerRegistration = navigator.serviceWorker.ready;

export {
  serviceWorkerRegistration,
}
/* serviceWorkerRegistration Not a pure module */
